/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './reset-password.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/auth/reset-password/reset-password.component';
import * as i3 from '@angular/forms';
import * as i4 from '../../shared/loading-indicator/loading-indicator.component.ngfactory';
import * as i5 from '../../../../app/shared/loading-indicator/loading-indicator.component';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from '../../../../app/shared/translations/translate.directive';
import * as i9 from '../../../../app/shared/translations/translations.service';
import * as i10 from '../../../../app/shared/settings.service';
import * as i11 from '../../../../app/auth/auth.service';
import * as i12 from '../../../../app/shared/toast/toast.service';
import * as i13 from '../../../../app/auth/current-user';
const styles_ResetPasswordComponent:any[] = [i0.styles];
export const RenderType_ResetPasswordComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ResetPasswordComponent,data:{}});
function View_ResetPasswordComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error email-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.email;
    _ck(_v,1,0,currVal_0);
  });
}
function View_ResetPasswordComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error password-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.password;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ResetPasswordComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),80,'form',[['class',
      'auth-page'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'ngSubmit'],[(null as any),'submit'],[(null as any),
      'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.ResetPasswordComponent = _v.component;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngSubmit' === en)) {
      const pd_2:any = ((<any>_co.resetPassword()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),{ngSubmit:'ngSubmit'}),i1.ɵprd(2048,(null as any),
      i3.ControlContainer,(null as any),[i3.NgForm]),i1.ɵdid(16384,(null as any),0,
      i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),(null as any)),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      73,'div',[['class','many-inputs auth-panel']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'loading-indicator',[['class',
          'overlay']],(null as any),(null as any),(null as any),i4.View_LoadingIndicatorComponent_0,
          i4.RenderType_LoadingIndicatorComponent)),i1.ɵdid(573440,(null as any),0,
          i5.LoadingIndicatorComponent,[i1.ElementRef],{isVisible:[0,'isVisible']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),3,'a',[['class','logo']],[[1,'target',
              0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,12).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i6.RouterLinkWithHref,
          [i6.Router,i6.ActivatedRoute,i7.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          0,'img',[['alt','logo']],[[8,'src',4]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'div',[['class','input-container']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'label',[['class','hidden'],['for','email'],['trans','']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4341760,(null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,
          i10.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['Email'])),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),8,'input',[['id','email'],['name','email'],['placeholder',
              'Email'],['required',''],['trans-placeholder',''],['type','email']],
          [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,23).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,23)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,23)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.email = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ResetPasswordComponent_1)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),18,'div',[['class','input-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'label',
          [['class','hidden'],['for','password'],['trans','']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(4341760,(null as any),
          0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['New Password'])),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),8,'input',[['id','password'],['name','password'],['placeholder',
              'Password'],['required',''],['trans-placeholder',''],['type','password']],
          [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,43)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,43).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,43)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,43)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.password = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ResetPasswordComponent_2)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),15,'div',[['class','input-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'label',
          [['class','hidden'],['for','password_confirmation'],['trans','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['Confirm New Password'])),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),8,'input',[['id','password_confirmation'],['name','password_confirmation'],
              ['placeholder','Confirm Password'],['required',''],['trans-placeholder',
                  ''],['type','password']],[[1,'required',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,63)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,63).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,63)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,63)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.password_confirmation = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'div',[['class','right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'button',[['class','button primary submit-button'],
          ['trans',''],['type','submit']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i8.TranslateDirective,
          [i1.ElementRef,i9.Translations,i10.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Reset Password'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.ResetPasswordComponent = _v.component;
    const currVal_7:any = _co.isLoading;
    _ck(_v,9,0,currVal_7);
    const currVal_10:any = _ck(_v,13,0,'/');
    _ck(_v,12,0,currVal_10);
    const currVal_20:any = '';
    _ck(_v,24,0,currVal_20);
    const currVal_21:any = 'email';
    const currVal_22:any = _co.model.email;
    _ck(_v,27,0,currVal_21,currVal_22);
    const currVal_23:any = _co.errors.email;
    _ck(_v,33,0,currVal_23);
    const currVal_32:any = '';
    _ck(_v,44,0,currVal_32);
    const currVal_33:any = 'password';
    const currVal_34:any = _co.model.password;
    _ck(_v,47,0,currVal_33,currVal_34);
    const currVal_35:any = _co.errors.password;
    _ck(_v,53,0,currVal_35);
    const currVal_44:any = '';
    _ck(_v,64,0,currVal_44);
    const currVal_45:any = 'password_confirmation';
    const currVal_46:any = _co.model.password_confirmation;
    _ck(_v,67,0,currVal_45,currVal_46);
  },(_ck,_v) => {
    var _co:i2.ResetPasswordComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,12).target;
    const currVal_9:any = i1.ɵnov(_v,12).href;
    _ck(_v,11,0,currVal_8,currVal_9);
    const currVal_11:any = _co.settings.get('branding.site_logo');
    _ck(_v,14,0,currVal_11);
    const currVal_12:any = (i1.ɵnov(_v,24).required? '': (null as any));
    const currVal_13:any = i1.ɵnov(_v,29).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,29).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,29).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,29).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,29).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,29).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,29).ngClassPending;
    _ck(_v,22,0,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
        currVal_18,currVal_19);
    const currVal_24:any = (i1.ɵnov(_v,44).required? '': (null as any));
    const currVal_25:any = i1.ɵnov(_v,49).ngClassUntouched;
    const currVal_26:any = i1.ɵnov(_v,49).ngClassTouched;
    const currVal_27:any = i1.ɵnov(_v,49).ngClassPristine;
    const currVal_28:any = i1.ɵnov(_v,49).ngClassDirty;
    const currVal_29:any = i1.ɵnov(_v,49).ngClassValid;
    const currVal_30:any = i1.ɵnov(_v,49).ngClassInvalid;
    const currVal_31:any = i1.ɵnov(_v,49).ngClassPending;
    _ck(_v,42,0,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,
        currVal_30,currVal_31);
    const currVal_36:any = (i1.ɵnov(_v,64).required? '': (null as any));
    const currVal_37:any = i1.ɵnov(_v,69).ngClassUntouched;
    const currVal_38:any = i1.ɵnov(_v,69).ngClassTouched;
    const currVal_39:any = i1.ɵnov(_v,69).ngClassPristine;
    const currVal_40:any = i1.ɵnov(_v,69).ngClassDirty;
    const currVal_41:any = i1.ɵnov(_v,69).ngClassValid;
    const currVal_42:any = i1.ɵnov(_v,69).ngClassInvalid;
    const currVal_43:any = i1.ɵnov(_v,69).ngClassPending;
    _ck(_v,62,0,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,
        currVal_42,currVal_43);
  });
}
export function View_ResetPasswordComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'reset-password',
      ([] as any[]),(null as any),(null as any),(null as any),View_ResetPasswordComponent_0,
      RenderType_ResetPasswordComponent)),i1.ɵdid(49152,(null as any),0,i2.ResetPasswordComponent,
      [i11.AuthService,i10.SettingsService,i6.ActivatedRoute,i6.Router,i12.ToastService,
          i13.CurrentUser],(null as any),(null as any))],(null as any),(null as any));
}
export const ResetPasswordComponentNgFactory:i1.ComponentFactory<i2.ResetPasswordComponent> = i1.ɵccf('reset-password',
    i2.ResetPasswordComponent,View_ResetPasswordComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/auth/reset-password/reset-password.component.ngfactory.ts